module.exports = __webpack_public_path__ + "static/imageCloud-29fac1987b4135d43e89f9070cf6ebbf.png";